import React, { useEffect, useRef, useState } from 'react';
import { FORM_CONFIG, PERSONAL_INFO } from '../constants/data';

const Contact = () => {
  const [formStatus, setFormStatus] = useState('');
  const resetTimerRef = useRef(null);

  useEffect(() => () => clearTimeout(resetTimerRef.current), []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('sending');

    const formData = new FormData(e.target);
    formData.append('access_key', FORM_CONFIG.accessKey);

    try {
      const response = await fetch(FORM_CONFIG.apiUrl, {
        method: 'POST',
        body: formData
      });
      const data = await response.json();

      if (data.success) {
        setFormStatus('success');
        e.target.reset();
        resetTimerRef.current = setTimeout(() => setFormStatus(''), 5000);
      } else {
        setFormStatus('error');
      }
    } catch (error) {
      setFormStatus('error');
    }
  };

  return (
    <section id="contact" className="section contact reveal">
      <div className="container">
        <div className="section-head">
          <span className="section-head__index">05</span>
          <h2 className="section-head__title">Contact</h2>
        </div>

        <div className="contact__grid">
          <div className="contact__intro">
            <h3 className="contact__headline">
              Let's build something<span className="accent"> worth shipping.</span>
            </h3>
            <p className="contact__desc">
              Have a project in mind — a product, an API, or an existing app that needs work?
              I'm currently {PERSONAL_INFO.status.toLowerCase()} and usually reply within a day.
            </p>
            <a href={`mailto:${PERSONAL_INFO.email}`} className="contact__email">
              {PERSONAL_INFO.email}
            </a>
            <p className="contact__location">
              <span className="accent-mono">⌖</span> {PERSONAL_INFO.location}
            </p>
          </div>

          <div className="contact__form-wrap">
            <form className="contact__form" onSubmit={handleSubmit}>
              <input type="hidden" name="subject" value={FORM_CONFIG.subject} />
              <input type="hidden" name="from_name" value={FORM_CONFIG.fromName} />
              <input
                type="checkbox"
                name="botcheck"
                tabIndex="-1"
                aria-hidden="true"
                autoComplete="off"
                className="contact__botcheck"
              />

              <div className="contact__row">
                <label className="contact__field">
                  <span className="contact__label">Name</span>
                  <input required type="text" name="name" placeholder="Your name" />
                </label>
                <label className="contact__field">
                  <span className="contact__label">Email</span>
                  <input required type="email" name="email" placeholder="you@company.com" />
                </label>
              </div>

              <label className="contact__field">
                <span className="contact__label">Message</span>
                <textarea
                  required
                  rows="5"
                  name="message"
                  placeholder="Tell me about your project…"
                />
              </label>

              <button
                type="submit"
                className="btn btn--solid contact__submit"
                disabled={formStatus === 'sending'}
              >
                {formStatus === 'sending' ? 'Sending…' : 'Send message'}
              </button>

              {formStatus === 'success' && (
                <p role="status" className="contact__status contact__status--ok">
                  Message sent — I'll get back to you soon.
                </p>
              )}
              {formStatus === 'error' && (
                <p role="alert" className="contact__status contact__status--err">
                  Something went wrong. Please try again or email me directly.
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
